/**
 * Hong Kong dollar.
 */
export var HKD = {
  code: 'HKD',
  base: 10,
  exponent: 2
};